import styles from './ModalFooter.module.css';
import { Button } from '../../Button/Button';

export interface ModalFooterProps {
  primaryButtonText: string;
  primaryButtonFunction: () => void;
  secondaryButtonText: string;
  secondaryButtonFunction: () => void;
}

export const ModalFooter = ({
  primaryButtonText,
  primaryButtonFunction,
  secondaryButtonText,
  secondaryButtonFunction,
}: ModalFooterProps) => {
  return (
    <div className={styles.ModalFooter}>
      <div className={styles.ModalFooter__secondary}>
        <Button variant="secondary" onClick={secondaryButtonFunction} isUppercase>
          {secondaryButtonText}
        </Button>
      </div>
      <div>
        <Button variant="primary" onClick={primaryButtonFunction}>
          {primaryButtonText}
        </Button>
      </div>
    </div>
  )
};
